//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
import { ISearchContextPropType } from "../../stores";
import {
  generateSearchSubject,
  transformOutput,
} from "../../stores/jobs/utils/misc";
import { transformSplit } from "./business-logic/request-splitter";
export const parentRequestsFunction = (
  tutorData,
  searchData: ISearchContextPropType,
) => {
  const { selectedTutor, generateAmount } = searchData;

  if (!tutorData) {
    return {};
  }

  const {
    price: { scheduleIsSet, amount, lessons },
    clientCountry,
    isTopRated,
    isPremium,
    isMonthly,
  } = tutorData?.additionalInfo || { price: {} };
  const hourlyRate = tutorData?.subject?.hourlyRate || 0;
  // } = interpretTutorData(tutorData, requestData, searchObj);
  const {
    userId,
    subject,
    isIndemand,
    rating,
    // students,
    lessonsTaught,
    newTutorDiscount,
    isNewTutor,
    entranceSchools: _entranceSchools,
    specialNeedExpertise,
    activeSubjects,
    ...data
  } = tutorData;
  let price = generateAmount(amount);
  let isSelected = selectedTutor === userId;

  let hasRating = rating > 0 || Boolean(rating);

  let isDiscounted =
    newTutorDiscount > 0 && (lessonsTaught === 0 || !Boolean(lessonsTaught));

  let discountRate = newTutorDiscount > 0 ? 1 - newTutorDiscount / 100 : 1;

  let discountedPrice = price * discountRate;

  return {
    isSelected,
    isPremium,
    userId,
    lessons,
    price,
    scheduleIsSet,
    isDiscounted,
    newTutorDiscount,
    isMonthly,
    hasRating,
    rating,
    isIndemand,
    lessonsTaught,
    subject,
    hourlyRate,
    discountedPrice,
    clientCountry,
    isTopRated,
    activeSubjects,
    ...data,
  };
};

const examPrepFunction = (tutorData) => {};

export const mapFunctionToRequestType = {
  ACADEMIC_REQUESTS: parentRequestsFunction,
  EXAM_PREP_REQUESTS: examPrepFunction,
};

export function UnixTimeConverter(unix_timestamp) {
  var msPerMinute = 60 * 1000;
  var msPerHour = msPerMinute * 60;
  var msPerDay = msPerHour * 24;
  var msPerMonth = msPerDay * 30;
  var msPerYear = msPerDay * 365;

  var elapsed = +new Date() - unix_timestamp;

  if (elapsed < msPerMinute) {
    return Math.round(elapsed / 1000) + " seconds ago";
  } else if (elapsed < msPerHour) {
    return Math.round(elapsed / msPerMinute) + " minutes ago";
  } else if (elapsed < msPerDay) {
    return Math.round(elapsed / msPerHour) + " hours ago";
  } else if (elapsed < msPerMonth) {
    return Math.round(elapsed / msPerDay) + " days ago";
  } else if (elapsed < msPerYear) {
    if (Math.round(elapsed / msPerMonth - 1) <= 1) {
      return "1 month ago";
    } else {
      return Math.round(elapsed / msPerMonth - 1) + " months ago";
    }
  } else {
    return Math.round(elapsed / msPerYear) + " years ago";
  }
}

export function generateSplitRequest(
  childDetails: any[],
  teacherOption: string,
) {
  //generating the teacher split option
  let transformedOutput = transformOutput({
    childDetails,
  });
  let result = transformSplit(transformedOutput);
  let options = Object.keys(result);
  let _teacherOptions = options.includes(teacherOption)
    ? teacherOption
    : options[0];
  let selection = result[_teacherOptions];
  if (selection) {
    let splits = generateSearchSubject(childDetails, selection);
    return splits;
  }
  return [];
}
